var $dc6e3b2813600d69$exports = {};
$dc6e3b2813600d69$exports = {
    "close": `Bez\xe1r\xe1s`,
    "notifications": `\xc9rtes\xedt\xe9sek`
};


export {$dc6e3b2813600d69$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
